import { TabValue } from './types';

export const DEFAULT_TAB: TabValue = 'published';
